class CatalogFilterForm {
    constructor(element) {
        this.filter = element;
        this.form = element.querySelector('[data-catalog-filter-form]');
        this.sortForm = document.querySelector('[data-catalog-filter-sort-form]');
        this.outer = document.querySelector('[data-catalog-filter-outer]');
        this.inner = document.querySelector('[data-catalog-filter-inner]');
        this.closer = this.filter.querySelector('[data-catalog-filter-closer]');
        this.addFilter = document.querySelector('[data-catalog-filter-add]');
        this.body = document.querySelector('body');

        this.filterOpener = document.querySelector('[data-filter-opener]');
        this.submitButton = this.filter.querySelector('[data-submit-button]');
        this.resetButton = this.filter.querySelector('[data-reset-button]');

        this.catalogTabs = document.querySelector('[data-catalog-tabs]');

        this.isMobile = false;
        this.isOpened = false;

        this.content = document.querySelector('[data-catalog-content]');
        this.debounce = _.debounce(() => this.request(), 1000);

        this.init();
        this.bind();
    }

    init() {
        this.defineMobile();
    }

    defineMobile() {
        this.isMobile = window.innerWidth < 1280;
    }

    bind() {
        this.bindSorter();
        this.bindForm();
        this.bindButtons();
        this.bindInputs();
        this.bindPagination();
        this.bindAddFilter();
        this.bindTabs();

        this.listeners();
    }

    bindTabs() {
        if (this.catalogTabs) {
            const link = this.catalogTabs.querySelector('[data-catalog-tabs-opener]');
            console.log(link)
            if (link) {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.catalogTabs.classList.remove('_close');
                });
            }
        }
    }

    bindAddFilter() {
        if (this.addFilter) {
            const links = Array.from(this.addFilter.querySelectorAll('[data-link-value]'));
            const radios = Array.from(this.form.querySelectorAll('input[name="CatalogFilterForm[additional]"]'));
            links.forEach((link) => {
               link.addEventListener('click', (e) => {
                   e.preventDefault();

                   link.classList.toggle('_active');
                   links
                     .filter((currentLink) => currentLink !== link)
                     .forEach((currentLink) => currentLink.classList.remove('_active'));


                   const inputValue = link.dataset.linkValue;
                   const selected = radios.find((input) => input.value === inputValue);
                   if (selected) {
                       console.log(!selected.checked)
                       selected.checked = !selected.checked;
                       selected.dispatchEvent(new Event('change'));
                   }
               })
            });
        }
    }

    listeners() {
        const instance = this;
        document.addEventListener('ToSmallHeader', (e) => {
            instance.inner.classList.add('_to-small-header');
            instance.filter.classList.add('_to-small-header');
        });

        document.addEventListener('ToBigHeader', (e) => {
            instance.inner.classList.remove('_to-small-header');
            instance.filter.classList.remove('_to-small-header');
        });

        window.addEventListener('resize', () => {
           instance.defineMobile();
        });
    }

    setLoading() {
        if (this.content) {
            this.content.classList.add('_loading');
        }
    }

    bindPagination() {
        const instance = this;

        const paginationLink = document.querySelector('[data-catalog-pagination] .next a');
        if (paginationLink) {
            paginationLink.addEventListener('click', (e) => {
                e.preventDefault();
                const jax = new Jax(
                    paginationLink.getAttribute('href'),
                    'GET',
                    false
                );

                jax.send().then((html) => {
                    const page = document.createElement('div');
                    page.innerHTML = html;

                    const currentList = document.querySelector('[data-catalog-content-products]');
                    const newList = page.querySelector('[data-catalog-content-products]');

                    const currentPagination = document.querySelector('[data-catalog-pagination]');
                    const newPagination = page.querySelector('[data-catalog-pagination]');

                    if (newPagination) {
                        currentPagination.innerHTML = newPagination.innerHTML;
                        instance.bindPagination();
                    } else {
                        currentPagination.remove();
                    }

                    Array.from(newList.children).forEach((child) => {
                        currentList.appendChild(child);
                    });

                    document.dispatchEvent(new Event('DOMContentMutated'));
                    document.dispatchEvent(new Event('update-product-counts'));
                });
            })
        }
    }

    bindSorter() {
        const instance = this;
        if (this.sortForm) {
            this.sortForm.addEventListener('submit', (e) => e.preventDefault());

            const sortSelect = this.sortForm.querySelector('select');
            if (sortSelect) {
                sortSelect.addEventListener('change', (e) => {
                    const value = sortSelect.value;
                    const radio = instance.filter.querySelector(`input[type="radio"][value="${value}"]`);

                    if (radio) {
                        radio.checked = 'checked';
                        radio.dispatchEvent(new Event('change'))
                    }
                });
            }
        }
    }

    bindButtons() {
        const instance = this;
        if (this.submitButton) {
            this.submitButton.addEventListener('click', (e) => {
                e.preventDefault();
                instance.setLoading();
                instance.debounce();
                if (this.isMobile) {
                    instance.closeFilter();
                }
            });
        }

        if (this.filterOpener) {
            this.filterOpener.addEventListener('click', (e) => {
                e.preventDefault();
                instance.openFilter();
            });
        }

        if (this.closer) {
            this.closer.addEventListener('click', (e) => {
                e.preventDefault();
                instance.closeFilter();
            })
        }

        if (this.resetButton) {
            this.resetButton.addEventListener('click', (e) => {
                e.preventDefault();
                instance.reset();
            })
        }
    }

    reset() {
        this.filter.querySelectorAll('input[type="checkbox"]').forEach((element) => {
            element.checked = element.dataset.defaultValue ? 'checked' : '';
            element.dispatchEvent(new Event('change'));
        })
    }

    bindForm() {
        const instance = this;
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            instance.setLoading();
            instance.debounce();
            return false;
        });
    }

    bindInputs() {
        const instance = this;
        this.filter.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((element) => {
            // if (!instance.isMobile) {
                element.addEventListener('change', (e) => {
                    console.log(e)
                    instance.setLoading();
                    instance.debounce();
                });
            // }
        })
    }

    request() {
        const currentProductList = document.querySelector('[data-catalog-content]');
        currentProductList.classList.add('_loading')

        const instance = this;
        const jax = new Jax(
            instance.form.getAttribute('action'),
            instance.form.getAttribute('method'),
            false
        );
        jax.send(new FormData(instance.form))
            .then((html) => {
                instance.replaceContent(html);
            });
    }



    replaceContent(html) {
        const page = document.createElement('div');
        page.innerHTML = html;

        const newProductList = page.querySelector('[data-catalog-content]');

        const newCount = page.querySelector('[data-catalog-product-count]');
        const oldCount = document.querySelector('[data-catalog-product-count]');
        const titleCount = document.querySelector('[data-title-count]');

        if (newProductList && this.content) {
            this.content.innerHTML = newProductList.innerHTML;
        }

        if (newCount && oldCount) {
            oldCount.innerHTML = newCount.innerHTML;
        }

        if (newCount && titleCount) {
            titleCount.innerHTML = newCount.innerHTML;
        }

        this.bindPagination();
        document.dispatchEvent(new Event('DOMContentMutated'));
        document.dispatchEvent(new Event('update-product-counts'));

        this.content.classList.remove('_loading');
    }

    openFilter() {
        this.isOpened = true;
        if (this.outer) {
            this.outer.classList.add('_opened');
            this.body.classList.add('_fixed');
        }
    }

    closeFilter() {
        this.isOpened = true;
        if (this.outer) {
            this.outer.classList.remove('_opened');
            this.body.classList.remove('_fixed');

        }
    }
}

document.addEventListener('DOMContentLoaded', ()=> {
    const element = document.querySelector('[data-catalog-filter]');
    if (element) {
        new CatalogFilterForm(element);
    }
});